import styled from 'styled-components';

export const HeaderSidebarPersonalWrapper = styled.div`
  display: unset;
  #hsp-top {
    width: 100%;
    background-color: var(--color-brick);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    align-content: center;
    padding: 2.5rem 0px 2rem 0px;
    .hsp-top-link-container {
      width: 100%;
      display: flex;
      align-items: stretch;
      justify-content: center;
      align-content: center;
      flex-direction: row;
      .hsp-top-link {
        color: var(--color-white);
        font-size: 2rem;
        &:hover {
          color: var(--color-black);
        }
      }
    }
    .border-left {
      border-left: 1px solid var(--color-white);
    }
    .border-right {
      border-right: 1px solid var(--color-white);
    }
  }
  .hsp-main-container {
    border-left: 1rem solid ${(props) => props.color};
    .hsp-links {
      display: grid;
      grid-template-areas: 'a a';
    }
  }
  @media (max-width: 991px) {
    margin: 0px;
  }
`;
